import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './sendSignInLinkMutation.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type SendSignInLinkMutation_Mutation = {
  __typename?: 'Mutation',
  sendSignInLink: boolean
};


export type SendSignInLinkMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  returnTo?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SendSignInLinkMutation = SendSignInLinkMutation_Mutation;


export const SendSignInLinkDocument = /*#__PURE__*/ document as unknown as DocumentNode<SendSignInLinkMutation, SendSignInLinkMutationVariables>;

export type SendSignInLinkMutationFn = ApolloReactCommon.MutationFunction<SendSignInLinkMutation, SendSignInLinkMutationVariables>;

/**
 * __useSendSignInLinkMutation__
 *
 * To run a mutation, you first call `useSendSignInLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignInLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignInLinkMutation, { data, loading, error }] = useSendSignInLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      returnTo: // value for 'returnTo'
 *   },
 * });
 */
export function useSendSignInLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSignInLinkMutation, SendSignInLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSignInLinkMutation, SendSignInLinkMutationVariables>(SendSignInLinkDocument, options);
      }
export type SendSignInLinkMutationHookResult = ReturnType<typeof useSendSignInLinkMutation>;
export type SendSignInLinkMutationResult = ApolloReactCommon.MutationResult<SendSignInLinkMutation>;
export type SendSignInLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<SendSignInLinkMutation, SendSignInLinkMutationVariables>;